import React from 'react';
import { useGetProfileActiveLimitOrders } from 'hooks/api/portfolio';
import MetricItem from 'components/MetricCard';

import messages from './IraUserActiveLimitOrders.messages';

type IraUserActiveLimitOrdersProps = {
  enableToFetch?: boolean;
};

const IraUserActiveLimitOrders: React.FC<IraUserActiveLimitOrdersProps> = ({
  enableToFetch = true,
}) => {
  const { isLoading, data } = useGetProfileActiveLimitOrders(enableToFetch);

  return (
    <MetricItem
      label={messages.label}
      amount={data?.limitOrdersLength}
      isLoading={isLoading}
      isUsd={false}
    />
  );
};

export default IraUserActiveLimitOrders;
